<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Ledger Account Group</div>
      </v-card-title>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :expanded.sync="expanded"
        show-expand
        :items="AccountSummary"
        :search="search"
        dense
        item-key="ledger_id"
      >
        <template #item.data-table-expand="{ item, expand, isExpanded }">
          <tr v-if="item.sub_ledger_list.length > 0" class="text-start">
            <v-btn
              icon
              title="Sub Categories"
              @click="expand(!isExpanded)"
              class="v-data-table__expand-icon"
              :class="{
                'v-data-table__expand-icon--active': isExpanded,
              }"
            >
              <v-icon :color="isExpanded ? 'primary' : ''"
                >mdi-chevron-down-circle</v-icon
              >
            </v-btn>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-4 mb-4">
            <div>
              SUB LEDGER LIST:
              <span class="font-weight-bold">{{ item.name }}</span>
            </div>
            <v-data-table
              fixed-header
              :headers="headers"
              :items="item.sub_ledger_list"
              :search="search"
              dense
              item-key="name"
              ><template v-slot:item.action="{ item }">
                <div class="d-flex">
                  <v-icon
                    small
                    title="Edit"
                    color="primary"
                    class="mr-2"
                    @click="getallLedgerById(item)"
                  >
                    mdi-content-save-edit-outline
                  </v-icon>
                  <v-icon
                    small
                    title="Delete"
                    color="primary"
                    class="mr-2"
                    @click="deleteItem(item)"
                  >
                    mdi-trash-can-outline
                  </v-icon>
                </div>
              </template>
            </v-data-table>
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="getallLedgerById(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-row class="ms-1 me-1 mt-5">
            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openDialog"
                ><v-icon small class="me-2">mdi-plus</v-icon>Add Ledger</v-btn
              >
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openLdgerDialog"
                ><v-icon small class="me-2">mdi-plus</v-icon>Add Sub
                Ledger</v-btn
              >
            </div>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span
                >{{ ledgerDetails.ledger_id ? "Update" : "Add" }}
                {{ adding_ledger_type }}
              </span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <!-- <v-radio-group
                  :disabled="ledgerDetails.ledger_id"
                  v-model="selectledgerType"
                  row
                  class="ms-3"
                >
                  <v-radio label="Ledger" value="new"></v-radio>
                  <v-radio label="Sub Ledger" value="exist"></v-radio>
                </v-radio-group> -->
                <v-col cols="12" md="12" v-if="selectledgerType === 'exist'">
                  <label class="my-0 rounded labelFontsize required"
                    >Existing Ledger
                  </label>
                  <v-autocomplete
                    class="rounded"
                    dense
                    :disabled="ledgerDetails.ledger_id"
                    v-model="ledgerDetails.parent_ledger_id"
                    @input="mapLedgerData(ledgerDetails.parent_ledger_id)"
                    :items="ledgerIds"
                    item-text="text"
                    item-value="value"
                    :rules="FieldRequired('Ledger Head')"
                    outlined
                    placeholder="Select Existing Ledger"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Ledger Name
                  </label>
                  <v-text-field
                    class="rounded"
                    :rules="[
                      ...FieldRequired('Ledger Name'),
                      ...ledgerNamerules,
                    ]"
                    dense
                    outlined
                    placeholder="Ledger Name"
                    v-model="ledgerDetails.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" v-if="selectledgerType == 'new'">
                  <label class="my-0 rounded labelFontsize required">
                    Ledger Type
                  </label>
                  <v-autocomplete
                    v-model="ledgerDetails.ledger_type"
                    :disabled="selectledgerType == 'exist'"
                    class="rounded"
                    :items="ledgerTypes"
                    :rules="FieldRequired('Ledger Type')"
                    dense
                    outlined
                    placeholder="Ledger Type"
                    item-text="txt"
                    item-value="val"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="selectledgerType == 'new'">
                  <label class="my-0 rounded labelFontsize required">
                    Account Type
                  </label>
                  <v-autocomplete
                    v-model="ledgerDetails.account_type"
                    class="rounded"
                    :items="ledgerAccountTypes"
                    :rules="FieldRequired('Account Type')"
                    dense
                    outlined
                    placeholder="Account Type"
                    item-text="txt"
                    item-value="val"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="selectledgerType == 'new'">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    v-model="ledgerDetails.country"
                    class="rounded"
                    dense
                    outlined
                    :rules="FieldRequired('Country')"
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="selectledgerType == 'new'">
                  <label class="my-0 rounded labelFontsize required">
                    Currency
                  </label>
                  <v-autocomplete
                    v-model="ledgerDetails.currency_code"
                    class="rounded"
                    dense
                    outlined
                    :rules="FieldRequired('Currency')"
                    placeholder="Currency"
                    :items="currency_list"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Description
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[...FieldRequired('Description'), ...ledgerDesc]"
                    placeholder="Description"
                    v-model="ledgerDetails.description"
                  ></v-text-field>
                </v-col>
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    justify-content: right;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="onSubmitFor()"
                  >
                    {{ ledgerDetails.ledger_id ? "Update" : "Add" }}
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteLedgerById()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired, ledgerRules } from "@/utils/validation.js";
import setupService from "@/services/SetupService/setupService.js";
export default {
  mixins: [alerts],
  name: "Account Details",
  data() {
    return {
      FieldRequired,
      // expanded: [],
      ...ledgerRules,
      search: "",
      dialogDelete: false,
      delete_id: null,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      showDialog: false,
      valid: true,
      editedIndex: -1,
      title_text: "",
      country_options: [],
      ledgerTypes: [],
      ledgerAccountTypes: [],
      ledgerIds: [],
      expanded: [],
      currency_list: [],
      country_obj: [],
      selectedCountry: "",
      selectledgerType: "new",
      adding_ledger_type: "Ledger",
      headers: [
        {
          text: "Id",
          sortable: false,
          value: "ledger_id",
        },
        { text: "Ledger Name", value: "name", sortable: false },
        { text: "Ledger Type", value: "ledger_type", sortable: false },
        { text: "Country", value: "country", sortable: false },
        { text: "Currency", value: "currency", sortable: false },
        { text: "Account Type", value: "account_type", sortable: false },
        { text: "Running Balance", value: "running_balance", sortable: false },
        {
          text: "Running Date",
          value: "running_balance_date",
          sortable: false,
        },
        { text: "Balance", value: "balance", sortable: false },
        { text: "Description", value: "description", sortable: false },
        { text: "Action", value: "action", sortable: false },
      ],
      AccountSummary: [],
      ledgerDetails: {
        name: "",
        ledger_type: null,
        parent_ledger_id: null,
        country: "",
        currency_code: "",
        account_type: "",
        balance: 0,
        description: "",
      },
      defaultledgerDetails: {
        name: "",
        ledger_type: null,
        parent_ledger_id: null,
        country: "",
        currency_code: "",
        account_type: "",
        balance: 0,
        description: "",
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getBeneCountryList();
    this.getparameterDropdown("LGT");
    this.getparameterDropdown("LAT");
    this.getallLedgers();
    this.getallLedgersDropdown();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  watch: {
    selectledgerType(val) {
      if (val == "new") {
        this.ledgerDetails.parent_ledger_id = null;
      }
    },
    "ledgerDetails.country"(val) {
      this.country_obj.map((ele) => {
        if (val === ele.val) {
          this.ledgerDetails.currency_code = ele.currency;
        }
      });
    },
  },
  methods: {
    async mapLedgerData(ledger_id) {
      if (ledger_id) {
        this.loader = true;
        try {
          const responseData = await setupService.getallLedgerById(ledger_id);
          console.log(`up: ${JSON.stringify(responseData)}`);
          this.loader = false;
          if (responseData.data.status_code === 200) {
            this.ledgerDetails.ledger_type =
              responseData.data.data[0].ledger_type;
            this.ledgerDetails.account_type =
              responseData.data.data[0].account_type;
            this.ledgerDetails.country = responseData.data.data[0].country;
            this.ledgerDetails.currency = responseData.data.data[0].currency;
          } else {
            this.showAlertError(responseData.data.message);
          }
        } catch (e) {
          this.showAlertError("fetch data Something went wrong");
          console.error(e);
        }
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async getallLedgersDropdown() {
      try {
        const responseData = await setupService.getallLedgersDropdown();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((ele) => {
            this.ledgerIds.push({
              text: ele.name,
              value: ele.ledger_id,
            });
          });
          console.log("this.ledgerIds", this.ledgerIds);
        }

        this.ledger_obj = responseData.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    async downloadExcelsheet() {
      if (this.AccountSummary) {
        this.exportToExcel(this.headers, this.AccountSummary, "AccountSummary");
      }
    },

    async getallLedgerById(item) {
      this.loader = true;
      try {
        const responseData = await setupService.getallLedgerById(
          item.ledger_id
        );
        console.log(`up: ${JSON.stringify(responseData)}`);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          // this.showAlertSuccess(responseData.data.message);
          this.ledgerDetails = responseData.data.data[0];
          this.ledgerDetails.parent_ledger_id
            ? (this.selectledgerType = "exist")
            : (this.selectledgerType = "new");
          this.showDialog = true;
        } else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },

    deleteItem(item) {
      this.showBlockDialog = true;
      this.delete_id = item.ledger_id;
    },
    openDialog() {
      this.selectledgerType = "new";
      this.adding_ledger_type = "Ledger";
      this.showDialog = true;
      this.ledgerDetails.ledger_id = null;
      this.ledgerDetails = Object.assign({}, this.defaultledgerDetails);
      this.$refs.Addform.resetValidation();
    },
    openLdgerDialog() {
      this.selectledgerType = "exist";
      this.adding_ledger_type = "Sub Ledger";
      this.showDialog = true;
      this.ledgerDetails.ledger_id = null;
      this.ledgerDetails = Object.assign({}, this.defaultledgerDetails);
      this.$refs.Addform.resetValidation();
    },
    closeDialog() {
      this.loader = false;
      this.showDialog = false;
      this.ledgerDetails.ledger_id = null;
      this.ledgerDetails = Object.assign({}, this.defaultledgerDetails);
      this.$refs.Addform.resetValidation();
    },
    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.ledgerDetails.ledger_id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async getallLedgers() {
      this.loader = true;

      try {
        const responseData = await setupService.getallLedgers();

        if (responseData.data.status_code === 200) {
          // this.showAlertSuccess(responseData.data.message);
          this.AccountSummary = responseData.data.data.reverse();
          this.ledgerIds = [];
          this.loader = false;
          this.getallLedgersDropdown();
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async deleteLedgerById() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteLedgerById(
          this.delete_id
        );
        console.log(`up: ${JSON.stringify(responseData)}`);

        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.showBlockDialog = false;
          this.getallLedgers();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.showBlockDialog = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.showBlockDialog = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async save() {
      this.loader = true;
      try {
        const responseData = await setupService.addNewLedger(
          this.ledgerDetails
        );
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.getallLedgers();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async update() {
      this.loader = true;

      try {
        const responseData = await setupService.updateledgerById(
          this.ledgerDetails.ledger_id,
          this.ledgerDetails
        );
        setTimeout(() => {
          this.loader = false;
        }, 300);
        if (responseData.data.status_code === 200) {
          this.getallLedgers();
          this.showAlertSuccess(responseData.data.message);
          this.showDialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
          this.currency_list = responseData.data.data.map(
            (i) => i.currency_code
          );
          this.country_obj = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
              currency: i.currency_code,
            };
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getparameterDropdown(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          if (code === "LGT") {
            this.ledgerTypes = response.data.data.map((i) => {
              return { txt: i.value, val: i.value_code };
            });
          } else if (code === "LAT") {
            this.ledgerAccountTypes = response.data.data.map((i) => {
              return { txt: i.value, val: i.value_code };
            });
          }

          this.loader = false;
        } else {
          this.loader = false;
        }
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
    },
    navBranchList(item) {
      this.$router.push({
        name: "Sample Ledger",
        query: { id: item.ledger_id, name: item.name },
      });
    },
    openBlockDialog(item) {
      this.title_text = item.status ? "Active" : "Deactive";
      this.showBlockDialog = true;
      this.isActive = item.status;
      this.blockId = item.partner_id;
    },
    confirmBlock() {
      this.showBlockDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
</style>
